import React from 'react'

import { levels } from '@config'
import { useIsTouch } from '@hooks'
import { useGameStore } from '@stores'

export const TutorialOverlay: React.FC = () => {
  const currentLevelIndex = useGameStore(state => state.currentLevelIndex)
  const currentTutorialStep = useGameStore(state => state.currentTutorialStep)
  const showTutorial = useGameStore(state => state.showTutorial)
  const nextTutorialStep = useGameStore(state => state.nextTutorialStep)
  const isTouch = useIsTouch()

  if (!showTutorial || currentTutorialStep === null) return null

  const levelConfig = levels[currentLevelIndex]
  const step = levelConfig.tutorialSteps?.[currentTutorialStep]

  if (!step) return null

  const isLevelEnd = currentLevelIndex === levels.length - 1

  return (
    <div
      onClick={nextTutorialStep}
      className="fixed inset-0 z-10000 flex flex-col items-center justify-start p-6 cursor-pointer animate-in fade-in duration-500"
    >
      <div className="w-full max-w-lg rounded-2xl border border-white/20 bg-white/15 p-5 shadow-2xl backdrop-blur-xl transition-all duration-300 hover:bg-white/30">
        <div className="mb-2 flex items-center gap-2 font-bold">
          <div className="flex size-8 items-center justify-center rounded-full overflow-hidden bg-teal-500 text-xl">
            <img src="/favicon/favicon-96x96.png" />
          </div>
          <span className="text-lg tracking-widest text-white uppercase">Vincent van Polp</span>
        </div>
        <p className="text-xl leading-relaxed text-white/90">{step.message}</p>
        <p className="font-bold mt-4 flex justify-end animate-bounce text-xs tracking-widest text-white/40 uppercase">
          {isLevelEnd
            ? 'Return to title screen'
            : `${isTouch ? 'Tap' : 'Click'} anywhere to continue`}
        </p>
      </div>
    </div>
  )
}
